$(document).ready(() => {
    $('.gformbuilderpro_content').each(function(){
      $(this).addClass('container');
    });

    $('.formbuilder_group').each(function(){
      $(this).addClass('row');
    });
});


// WEBPACK FOOTER //
// ./js/formbuilder.js